import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import Navbar from '../pages/Navbar';

function ComboPage() {
  const { location, category } = useParams();
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api.get(`/slugs/${location}/${category}`)
      .then((res) => setResult(res.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [location, category]);

  if (loading) return <div className="p-10 text-center text-gray-500">Loading...</div>;
  if (notFound || !result) return <div className="p-10 text-center text-gray-500">Nothing found here.</div>;

  const heading = `${result.category_name} Jobs in ${result.location_name}`;

  return (
    <div className="min-h-screen bg-secondary-blue">
      <Navbar />
      <div className="max-w-5xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">{heading}</h1>
        <p className="text-sm text-gray-500 mb-8">
          Browse {result.jobs.length} open position{result.jobs.length === 1 ? '' : 's'}.
        </p>
        <div className="space-y-2">
          {result.jobs.map((job) => (
            <button
              key={job.id}
              onClick={() => navigate(`/jobs/${job.id}`)}
              className="w-full text-left p-4 rounded-xl border border-gray-200 hover:border-primary-blue transition bg-white"
            >
              <p className="font-semibold text-gray-800">{job.title}</p>
              <p className="text-sm text-gray-500">{job.company_name}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ComboPage;